// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact[data-v-a28f3e56]{margin-top:-5rem;background:linear-gradient(var(--v-light-grey-base),var(--v-light-grey-base) 50%,var(--v-white-base) 0,var(--v-white-base))}.contact__card[data-v-a28f3e56]{width:100%;padding:0 6.5rem}.contact__button.white[data-v-a28f3e56]{border-color:var(--v-light-grey-base)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
